import ViewCategoriesAndProducts from './ViewCategoriesAndProducts';
export default ViewCategoriesAndProducts;
